import React from 'react'
import { Badge, type BadgeColor } from '@enamelai/design-system'
import { StatusTypes } from '@components/common/StatusBadge/StatusBadge.component'
import { PATIENT_STATUS_BADGE_COLOR } from '@constants/PatientManagement/status'

/** Appointment statuses follow the design-system scheduler (SCHEDULER_STATUS_BADGE_COLOR). */
export const PROFILE_STATUS_BADGE_COLOR: Partial<
  Record<StatusTypes, BadgeColor>
> = {
  ...PATIENT_STATUS_BADGE_COLOR,
  [StatusTypes.Unconfirmed]: 'gray',
  [StatusTypes.Confirmed]: 'pale-green',
  [StatusTypes.Late]: 'orange',
  [StatusTypes.NoShow]: 'red',
  [StatusTypes.CheckIn]: 'blue',
  [StatusTypes.InTreatment]: 'purple',
  [StatusTypes.CheckOut]: 'cyan',
  [StatusTypes.Completed]: 'vivid-green',
  [StatusTypes.Complete]: 'vivid-green',
  [StatusTypes.Approved]: 'vivid-green',
  [StatusTypes.Verified]: 'vivid-green',
  [StatusTypes.Denied]: 'red',
  [StatusTypes.Rejected]: 'red',
  [StatusTypes.UnderReview]: 'yellow',
  [StatusTypes.NA]: 'gray',
}

type ProfileStatusBadgeProps = {
  status?: StatusTypes | string | null
  className?: string
}

function ProfileStatusBadge({
  status,
  className,
}: ProfileStatusBadgeProps): React.ReactElement {
  if (!status) return <span className={className}>—</span>
  return (
    <Badge
      className={className}
      mode="tinted"
      color={PROFILE_STATUS_BADGE_COLOR[status as StatusTypes] ?? 'gray'}
      label={status}
    />
  )
}

export default ProfileStatusBadge
